export const actionTypes: any = {
  // get fAQ ICON TYPE
  GET_FAQ_ICON_TYPE_START: 'GET_FAQ_ICON_TYPE_START',
  GET_FAQ_ICON_TYPE_SUCCESS: 'GET_FAQ_ICON_TYPE_SUCCESS',
  GET_FAQ_ICON_TYPE_FINISH: 'GET_FAQ_ICON_TYPE_FINISH',
}
